require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./information-security-and-quality-assurance-information-security-and-quality-assurance-projects-stock-price-checker.json") })
        }
      }, "path---information-security-and-quality-assurance-information-security-and-quality-assurance-projects-stock-price-checker");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---information-security-and-quality-assurance-information-security-and-quality-assurance-projects-stock-price-checker!./.cache/json/information-security-and-quality-assurance-information-security-and-quality-assurance-projects-stock-price-checker.json
// module id = 2169
// module chunks = 231608221292675